var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: (_vm.ApplyCreateApply, _vm.ApplyUpdate),
                    expression: "ApplyCreateApply,ApplyUpdate",
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saveBtnShow,
                    expression: "saveBtnShow",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.saveQuotationApply()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("common.save")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.ApplySubmitApply,
                    expression: "ApplySubmitApply",
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.submitBtnShow,
                    expression: "submitBtnShow",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.submitQuotationApply },
              },
              [_vm._v(_vm._s(_vm.$t("common.submit")))]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.historyBack },
              },
              [_vm._v(_vm._s(_vm.$t("common.close")))]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "applyInfoForm",
                attrs: {
                  model: _vm.applyData,
                  "label-position": _vm.labelPosition,
                  rules: _vm.applyRules,
                  "label-width": "140px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("apply.no") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: true },
                              model: {
                                value: _vm.applyData.applyNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "applyNo", $$v)
                                },
                                expression: "applyData.applyNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.applyType"),
                              prop: "applyType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.applyData.applyType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.applyData, "applyType", $$v)
                                  },
                                  expression: "applyData.applyType",
                                },
                              },
                              _vm._l(_vm.applyTypeList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm._f("inputChoiceI18n")(item),
                                    value: item.code,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 17 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.subject"),
                              prop: "subject",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: _vm.disableEditor },
                              model: {
                                value: _vm.applyData.subject,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "subject", $$v)
                                },
                                expression: "applyData.subject",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.shortlistedSuppliers"),
                              prop: "supplierNames",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: {
                                readonly: true,
                                disabled: _vm.disableEditor,
                                "suffix-icon": "el-icon-search",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.showSelSupplierDialog =
                                    _vm.disableEditor == false ? true : false
                                },
                              },
                              model: {
                                value: _vm.applyData.supplierNames,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "supplierNames", $$v)
                                },
                                expression: "applyData.supplierNames",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.quotationType"),
                              prop: "quotationType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                attrs: { disabled: _vm.disableEditor },
                                model: {
                                  value: _vm.applyData.quotationType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.applyData,
                                      "quotationType",
                                      $$v
                                    )
                                  },
                                  expression: "applyData.quotationType",
                                },
                              },
                              _vm._l(
                                _vm.quotationTypeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm._f("inputChoiceI18n")(item),
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.createBy") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: true },
                              model: {
                                value: _vm.applyData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "name", $$v)
                                },
                                expression: "applyData.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.createDate") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: true },
                              model: {
                                value: _vm.applyData.createDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "createDate", $$v)
                                },
                                expression: "applyData.createDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: _vm.$t("apply.lineDetail"), name: "line" } },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "flex", justify: "start", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.applyLineEdit,
                            expression: "applyLineEdit",
                          },
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.ApplyCreateApplyLine,
                            expression: "ApplyCreateApplyLine",
                          },
                        ],
                        staticClass: "btn",
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.showApplyLineAddDialogFunc },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.applyLineEdit,
                            expression: "applyLineEdit",
                          },
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.ApplyDeleteApplyLine,
                            expression: "ApplyDeleteApplyLine",
                          },
                        ],
                        staticClass: "btn",
                        attrs: { size: "mini", type: "danger" },
                        on: { click: _vm.delSelQuotationApplyLine },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.del")))]
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.applyLineEdit,
                            expression: "applyLineEdit",
                          },
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.ApplyDeleteApplyLine,
                            expression: "ApplyDeleteApplyLine",
                          },
                        ],
                        staticClass: "apply-import-button",
                        attrs: {
                          "on-error": _vm.importDetailError,
                          "on-success": _vm.importDetailSuccess,
                          "before-upload": _vm.beforeUpload,
                          "show-file-list": false,
                          action: _vm.importDetailUrl,
                          multiple: "false",
                          headers: _vm.headers,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "mini", type: "primary" } },
                          [_vm._v(_vm._s(_vm.$t("common.import")))]
                        ),
                      ],
                      1
                    ),
                    _vm.ttQuotationApplyId !== -99999
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.ApplyCreateApplyLine,
                                expression: "ApplyCreateApplyLine",
                              },
                            ],
                            staticClass: "btn",
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.onExport },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.export")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-link",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.applyLineEdit,
                            expression: "applyLineEdit",
                          },
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.ApplyDeleteApplyLine,
                            expression: "ApplyDeleteApplyLine",
                          },
                        ],
                        attrs: {
                          type: "button",
                          target: "_blank",
                          href: "static/template/RFQ(Line)Template.xlsx",
                          download: "RFQ(Line)Template.xlsx",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "mini", type: "primary" } },
                          [_vm._v(_vm._s(_vm.$t("common.templateDownload")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.lineChangeApplyFlag
                  ? _c(
                      "ux-grid",
                      {
                        ref: "applyLineTableDataRef",
                        attrs: {
                          data: _vm.applyLineTableData,
                          "keep-source": "",
                          "max-height": "450",
                          "highlight-current-row": "",
                          "show-overflow": "tooltip",
                        },
                      },
                      [
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            type: "checkbox",
                            width: "80",
                          },
                        }),
                        _c("ux-table-column", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.disableEditor,
                              expression: "!disableEditor",
                            },
                          ],
                          attrs: {
                            align: "center",
                            title: "操作",
                            width: "80",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("i", {
                                      staticClass: "el-icon-edit-outline",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onEdit(scope)
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3450542797
                          ),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            title: "序号",
                            type: "index",
                            width: "60",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "pickupPoint",
                            title: _vm.$t("base.pp.pickupPoint"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "dcName",
                            title: _vm.$t("apply.dc"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.tmDcId,
                                            "BASE",
                                            "DC"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            97485839
                          ),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "temperature",
                            title: _vm.$t("apply.temperature"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.temperature,
                                            "COMMON",
                                            "TEMPERATURE"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            636025187
                          ),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "transportaionMethod",
                            title: _vm.$t("apply.transportaionMethod"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.transportaionMethod,
                                            "COMMON",
                                            "TRANSPORTAION_METHOD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2580796764
                          ),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "unit",
                            title: _vm.$t("apply.unit"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.unit,
                                            "COMMON",
                                            "UNIT"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            844796803
                          ),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "effectiveBeginDate",
                            title: _vm.$t("apply.effectiveBeginDate"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormatFilter")(
                                            scope.row.effectiveBeginDate,
                                            "YYYY-MM-DD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1544433441
                          ),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "lineType",
                            title: _vm.$t("apply.lineType"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.lineType,
                                            "TT_QUOTATION_APPLY_LINE",
                                            "LINE_TYPE"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1774710582
                          ),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "remarks",
                            title: _vm.$t("common.remarks"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "ux-grid",
                      {
                        ref: "applyLineTableDataRef1",
                        attrs: {
                          data: _vm.applyLineTableData,
                          "max-height": "450",
                          "keep-source": "",
                          "show-overflow": "tooltip",
                        },
                      },
                      [
                        _c("ux-table-column", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.disableEditor,
                              expression: "!disableEditor",
                            },
                          ],
                          attrs: {
                            align: "center",
                            title: "操作",
                            width: "80",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("i", {
                                    staticClass: "el-icon-edit-outline",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEdit1(scope)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            title: "序号",
                            type: "index",
                            width: "60",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "pickupPoint",
                            title: _vm.$t("base.pp.pickupPoint"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "dcName",
                            title: _vm.$t("apply.dc"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "temperature",
                            title: _vm.$t("apply.temperature"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.temperature,
                                          "COMMON",
                                          "TEMPERATURE"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "transportaionMethod",
                            title: _vm.$t("apply.transportaionMethod"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.transportaionMethod,
                                          "COMMON",
                                          "TRANSPORTAION_METHOD"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "originalSupplierName",
                            title: _vm.$t("apply.originalSupplier"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "originalPrice",
                            title: _vm.$t("apply.originalPrice"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "unit",
                            title: _vm.$t("apply.unit"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.unit,
                                          "COMMON",
                                          "UNIT"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "effectiveBeginDate",
                            title: _vm.$t("apply.effectiveBeginDate"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFormatFilter")(
                                          scope.row.effectiveBeginDate,
                                          "YYYY-MM-DD"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "lineType",
                            title: _vm.$t("apply.lineType"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.lineType,
                                          "TT_QUOTATION_APPLY_LINE",
                                          "LINE_TYPE"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            field: "remarks",
                            title: _vm.$t("common.remarks"),
                            resizable: "",
                            align: "center",
                            sortable: "",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("common.attachment"),
                  name: "enclosure",
                },
              },
              [
                _c(
                  "el-upload",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showUploadFlag,
                        expression: "showUploadFlag",
                      },
                    ],
                    ref: "upload",
                    staticStyle: { float: "left" },
                    attrs: {
                      action: "upload",
                      "http-request": _vm.uploadConfirm,
                      "show-file-list": false,
                      multiple: "",
                      name: "file",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          slot: "trigger",
                          size: "mini",
                          type: "primary",
                        },
                        slot: "trigger",
                      },
                      [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    staticClass: "table",
                    attrs: {
                      data: _vm.fileList,
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "documentName",
                        label: _vm.$t("common.file"),
                        "min-width": "130px",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadFile(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.documentName) + " ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "userName",
                        label: _vm.$t("common.createBy"),
                        "min-width": "130px",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "createDate",
                        label: _vm.$t("common.createDate"),
                        "min-width": "130px",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("dateFormatFilter")(
                                      scope.row.createDate,
                                      "YYYY-MM-DD HH:mm"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.showUploadFlag
                      ? _c("el-table-column", {
                          attrs: { prop: "tmDocumentId", "min-width": "130px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.deleteFile(
                                              scope.row.tmDocumentId,
                                              scope.$index,
                                              _vm.fileList
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.del")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4140023628
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showSelSupplierDialog,
              "append-to-body": "",
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showSelSupplierDialog = $event
              },
            },
          },
          [
            _c("SelSupplier", {
              ref: "supplierSelRef",
              on: { subCallMethod: _vm.selectSupplierMethod },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showSelPickupPointDialog,
              "append-to-body": "",
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showSelPickupPointDialog = $event
              },
            },
          },
          [
            _c("SelPickupPoint", {
              ref: "selPickupPointRef",
              on: { subCallMethod: _vm.selectPickupPointMethod },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showSelDcDialog,
              "append-to-body": "",
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showSelDcDialog = $event
              },
            },
          },
          [
            _c("SelDc", {
              ref: "selectDcRef",
              attrs: {
                showFlag: _vm.showSelDcDialog,
                multipleSelectionFlag: true,
              },
              on: { subCallMethod: _vm.selectDcMethod },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showSelDcMultipleDialog,
              "append-to-body": "",
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showSelDcMultipleDialog = $event
              },
            },
          },
          [
            _c("SelDc", {
              ref: "selectDcMultipleRef",
              attrs: { multipleSelectionFlag: false },
              on: { subCallMethod: _vm.selectDcMethod },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.$t("apply.detailCreate"),
              "close-on-click-modal": false,
              visible: _vm.showApplyLineAddDialog,
              width: "600px",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showApplyLineAddDialog = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "aplyLineNewForm",
                staticClass: "form_border lineClass",
                attrs: {
                  model: _vm.applyLineNew,
                  rules: _vm.applyLineNewRules,
                  "label-position": _vm.labelPosition,
                  "label-width": "130px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "space-around" } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              clss: "redSpan",
                              label: _vm.$t("base.pp.pickupPoint"),
                              placeholder: "",
                              prop: "pickupPoint",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "handle-input ABC",
                              attrs: { "suffix-icon": "el-icon-search" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.showSelPickupPointDialogFunc()
                                },
                              },
                              model: {
                                value: _vm.applyLineNew.pickupPoint,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyLineNew, "pickupPoint", $$v)
                                },
                                expression: "applyLineNew.pickupPoint",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              clss: "redSpan",
                              label: "DC",
                              placeholder: "",
                              prop: "dcName",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: {
                                "suffix-icon": "el-icon-search",
                                readonly: true,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.showSelDcDialogFunc("2")
                                },
                              },
                              model: {
                                value: _vm.applyLineNew.dcName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyLineNew, "dcName", $$v)
                                },
                                expression: "applyLineNew.dcName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.temperature"),
                              placeholder: "",
                              prop: "temperature",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                model: {
                                  value: _vm.applyLineNew.temperature,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.applyLineNew,
                                      "temperature",
                                      $$v
                                    )
                                  },
                                  expression: "applyLineNew.temperature",
                                },
                              },
                              _vm._l(
                                _vm.temperatureList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm._f("inputChoiceI18n")(item),
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.effectiveBeginDate"),
                              placeholder: "",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticClass: "handle-input",
                              attrs: {
                                "value-format": "yyyy-MM-dd",
                                type: "date",
                                placeholder: _vm.$t("common.selDate"),
                              },
                              model: {
                                value: _vm.applyLineNew.effectiveBeginDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.applyLineNew,
                                    "effectiveBeginDate",
                                    $$v
                                  )
                                },
                                expression: "applyLineNew.effectiveBeginDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer", align: "center" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.createApplyLineNew },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.showApplyLineAddDialog = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "报价明细",
              visible: _vm.dialogEditVisible,
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogEditVisible = $event
              },
              close: _vm.onCancel,
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "tableDataRef",
                staticClass: "table",
                attrs: {
                  "min-height": "450",
                  data: _vm.tableData,
                  border: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "tmPickupId",
                    label: _vm.$t("base.pp.pickupPoint"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            attrs: { "suffix-icon": "el-icon-search" },
                            on: {
                              focus: function ($event) {
                                return _vm.showSelPickupPointDialogFunc(
                                  scope.row
                                )
                              },
                            },
                            model: {
                              value: scope.row.pickupPoint,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "pickupPoint", $$v)
                              },
                              expression: "scope.row.pickupPoint",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "tmDcId",
                    label: _vm.$t("apply.dc"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            attrs: { "suffix-icon": "el-icon-search" },
                            on: {
                              focus: function ($event) {
                                return _vm.showSelDcDialogFunc("1", scope.row)
                              },
                            },
                            model: {
                              value: scope.row.dcName,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "dcName", $$v)
                              },
                              expression: "scope.row.dcName",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "temperature",
                    label: _vm.$t("apply.temperature"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              model: {
                                value: scope.row.temperature,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "temperature", $$v)
                                },
                                expression: "scope.row.temperature",
                              },
                            },
                            _vm._l(_vm.temperatureList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "transportaionMethod",
                    label: _vm.$t("apply.transportaionMethod"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              model: {
                                value: scope.row.transportaionMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "transportaionMethod",
                                    $$v
                                  )
                                },
                                expression: "scope.row.transportaionMethod",
                              },
                            },
                            _vm._l(
                              _vm.transportaionMethodList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm._f("inputChoiceI18n")(item),
                                    value: item.code,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "unit",
                    label: _vm.$t("apply.unit"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              model: {
                                value: scope.row.unit,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "unit", $$v)
                                },
                                expression: "scope.row.unit",
                              },
                            },
                            _vm._l(_vm.unitList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    "min-width": "200px",
                    prop: "effectiveBeginDate",
                    label: _vm.$t("apply.effectiveBeginDate"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-date-picker", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t("common.selDate"),
                            },
                            model: {
                              value: scope.row.effectiveBeginDate,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "effectiveBeginDate", $$v)
                              },
                              expression: "scope.row.effectiveBeginDate",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "lineType",
                    label: _vm.$t("apply.lineType"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              model: {
                                value: scope.row.lineType,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "lineType", $$v)
                                },
                                expression: "scope.row.lineType",
                              },
                            },
                            _vm._l(_vm.lineTypeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "remarks",
                    label: _vm.$t("common.remarks"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            model: {
                              value: scope.row.remarks,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "remarks", $$v)
                              },
                              expression: "scope.row.remarks",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                  [_vm._v("确认")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "报价明细",
              visible: _vm.dialogEditVisible1,
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogEditVisible1 = $event
              },
              close: _vm.onCancel1,
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "tableDataRef1",
                staticClass: "table",
                attrs: {
                  data: _vm.tableData1,
                  border: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "pickupPoint",
                    label: _vm.$t("base.pp.pickupPoint"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "tmDcId",
                    label: _vm.$t("apply.dc"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "temperature",
                    label: _vm.$t("apply.temperature"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "transportaionMethod",
                    label: _vm.$t("apply.transportaionMethod"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    sortable: "",
                    prop: "originalSupplierName",
                    label: _vm.$t("apply.originalSupplier"),
                    "min-width": "160",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    sortable: "",
                    prop: "originalPrice",
                    label: _vm.$t("apply.originalPrice"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "unit",
                    label: _vm.$t("apply.unit"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              model: {
                                value: scope.row.unit,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "unit", $$v)
                                },
                                expression: "scope.row.unit",
                              },
                            },
                            _vm._l(_vm.unitList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    "min-width": "200px",
                    prop: "effectiveBeginDate",
                    label: _vm.$t("apply.effectiveBeginDate"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-date-picker", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              "picker-options": _vm.dateLimit,
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t("common.selDate"),
                            },
                            model: {
                              value: scope.row.effectiveBeginDate,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "effectiveBeginDate", $$v)
                              },
                              expression: "scope.row.effectiveBeginDate",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "lineType",
                    label: _vm.$t("apply.lineType"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              model: {
                                value: scope.row.lineType,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "lineType", $$v)
                                },
                                expression: "scope.row.lineType",
                              },
                            },
                            _vm._l(_vm.lineTypeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "remarks",
                    label: _vm.$t("common.remarks"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            model: {
                              value: scope.row.remarks,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "remarks", $$v)
                              },
                              expression: "scope.row.remarks",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onCancel1 } },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onConfirm1 } },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }